import React, { useRef, useEffect } from 'react';
import { styled, Shape } from '@teko/ds-desktop';
import ProductGiftItem from './ProductGiftItem.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';

const ProductGifts = (props) => {
  var _a;
  const { gifts, hasGift } = props;
  const { isMobile } = useDevice();
  const containerRef = useRef(null);
  const startPos = useRef({
    startX: 0,
    scrollLeft: 0,
    isMouseDown: false
  });
  useEffect(() => {
    const container = containerRef.current;
    const handleMouseDown = (e) => {
      if (!container) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      const startX = e.pageX - container.offsetLeft;
      const scrollLeft = container.scrollLeft;
      startPos.current = {
        startX,
        scrollLeft,
        isMouseDown: true
      };
      document.body.style.cursor = "grabbing";
    };
    const handleMouseMove = (e) => {
      if (!startPos.current.isMouseDown || !container) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walkX = x - startPos.current.startX;
      container.scrollLeft = startPos.current.scrollLeft - walkX;
    };
    const handleMouseUp = () => {
      if (!container) {
        return;
      }
      startPos.current.isMouseDown = false;
      document.body.style.cursor = "default";
    };
    container == null ? void 0 : container.addEventListener("mousedown", handleMouseDown);
    container == null ? void 0 : container.addEventListener("mousemove", handleMouseMove);
    container == null ? void 0 : container.addEventListener("mouseup", handleMouseUp);
    return () => {
      container == null ? void 0 : container.removeEventListener("mousedown", handleMouseDown);
      container == null ? void 0 : container.removeEventListener("mousemove", handleMouseMove);
      container == null ? void 0 : container.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);
  if (!hasGift || !((_a = gifts == null ? void 0 : gifts.images) == null ? void 0 : _a.length))
    return null;
  return /* @__PURE__ */ React.createElement(Container, {
    ref: containerRef,
    padding: "s4",
    borderRadius: "m",
    backgroundColor: "background",
    marginBottom: isMobile ? "s12" : void 0,
    onClick: (e) => e.preventDefault()
  }, gifts.images.map((image, index) => {
    return /* @__PURE__ */ React.createElement(ProductGiftItem, {
      key: index,
      gift: image
    });
  }));
};
var ProductGifts$1 = ProductGifts;
const Container = styled(Shape)`
  overflow: auto hidden;
  gap: 4px;
  display: flex;
  flex-direction: row;
  ::-webkit-scrollbar {
    //Hide scrollbar for Chrome, Safari and Opera
    display: none;
  }
  // Hide scrollbar for IE and Edge
  -ms-overflow-style: none;
  // Hide scrollbar for Firefox
  scrollbar-width: none;
`;

export { ProductGifts$1 as default };
